(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    const initializeSimpleCart = () => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.dataset.simpleCartReady) return;
    drawer.dataset.simpleCartReady = 'true';
    const products = drawer.querySelector('[data-products]');
    const clock = drawer.querySelector('[data-cart-timer]');
    const timerKey = 'isabelle-cart-timer-v2';
    let deadline = 0;
    try { deadline = Number(sessionStorage.getItem(timerKey)) || 0; } catch (error) {}
    const updateTimer = () => {
      if (drawer.classList.contains('is-empty')) {
        deadline = 0;
        try { sessionStorage.removeItem(timerKey); } catch (error) {}
        clock.textContent = '10:00';
        return;
      }
      if (!drawer.classList.contains('drawer--is-open')) return;
      if (!deadline || deadline <= Date.now()) {
        deadline = Date.now() + 600000;
        try { sessionStorage.setItem(timerKey, String(deadline)); } catch (error) {}
      }
      clock.dataset.deadline = String(deadline);
      const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
      clock.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    };
    new MutationObserver(updateTimer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('visibilitychange', updateTimer);
    window.addEventListener('storage', event => {
      if (event.key === timerKey) { deadline = Number(event.newValue) || 0; updateTimer(); }
    });
    window.setInterval(updateTimer, 1000);
    updateTimer();
    const syncSummary = () => {
      const progress = products.querySelector('template[data-progress-template]');
      const summary = products.querySelector('template[data-summary-template]');
      if (progress) drawer.querySelector('[data-cart-progress]').replaceChildren(progress.content.cloneNode(true));
      if (summary) drawer.querySelector('[data-cart-summary]').replaceChildren(summary.content.cloneNode(true));
      const count = drawer.querySelector('[data-summary-count]');
      if (count) drawer.querySelector('[data-simple-count]').textContent = '(' + count.dataset.summaryCount + ')';
    };
    new MutationObserver(syncSummary).observe(products, { childList: true });
    syncSummary();
    drawer.addEventListener('click', event => {
      const remove = event.target.closest('[data-cart-remove]');
      if (!remove) return;
      event.preventDefault();
      const input = remove.closest('.cart__item').querySelector('.js-qty__num');
      input.value = '0';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSimpleCart, { once: true });
  else initializeSimpleCart();
  document.addEventListener('shopify:section:load', initializeSimpleCart);
  } catch(e) { console.error(e); }
})();

})();
